module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "theform"
    }
  }, [_c('input', {
    attrs: {
      "id": "upload",
      "type": "file",
      "name": "head",
      "accept": "image/png, image/jpeg, image/jpg"
    },
    on: {
      "change": _vm.getImg
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("给自己取个喜欢的昵称，做一朵不一样的烟火")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "thename"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "label": "请输入昵称",
      "fullWidth": true,
      "labelFloat": ""
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "确定",
      "fullWidth": true,
      "secondary": ""
    },
    on: {
      "click": function($event) {
        _vm.setName('top')
      }
    }
  })], 1), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "top",
      "overlay": false,
      "popupClass": "demo-popup-top",
      "open": _vm.topPopup
    }
  }, [_vm._v("\n        请输入正确的格式\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "avatar-container"
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('span', {
    staticClass: "edit-avatar"
  }, [_vm._v("更换头像")]), _vm._v(" "), _c('img', {
    staticClass: "headpic",
    attrs: {
      "src": require("../../../images/login&reg&mine/step2.png")
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7192a64a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7192a64a","hasScoped":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/router/router/regstep2.vue
// module id = 201
// module chunks = 0